import React from 'react'
import PropTypes from 'prop-types'
import FormSelect from 'components/forms/bases/FormSelect'

const ColorsSelector = ({
  ...props,
}) => {
  return (
    <FormSelect
      {...props}
      label="Colors"
      options={
        [
          '',
          'red',
          'orange',
          'yellow',
          'olive',
          'green',
          'teal',
          'blue',
          'violet',
          'purple',
          'pink',
          'brown',
          'white',
          'black',
        ]
      }
    />
  )
}

ColorsSelector.propTypes = {}
ColorsSelector.defaultProps = {}

export default ColorsSelector



// WEBPACK FOOTER //
// ./src/components/forms/ColorsSelector.js